import apiFetch from '../apiFetch'

export default function (token, metadatoList) {
  return apiFetch({ endPoint: `MetadataList/${metadatoList.metadatoListId}`, method: 'PUT', body: metadatoList, token: token })
}
